import React from "react";
import { Alert } from "antd";
import { useSelector } from "react-redux";
import { esZonaRoja } from "./zonasRojas";

export const AlertaZonaRoja = () => {
  const asistencia = useSelector((state) => state.detalleReducer.asistencia);
  if (!esZonaRoja(asistencia)) return null;

  return (
    <Alert
      message="¡Alerta! El usuario se encuentra en zona roja."
      type="error"
      showIcon
      style={{ marginBottom: 10 }}
    />
  );
};
